import React from 'react';
import { FormattedMessage } from 'react-intl';

import UserDateTimezoneFormat from '../../../../../../components/user-date-timezone-format';
import { advancedShippingNoticeGridProperties } from '../grid-properties';
import { messages } from '../messages';

const name = <FormattedMessage {...messages.dateLastUpdatedColumnHeader} />;

/**
 * Date Last Updated column configuration
 * Displays the last update date formatted
 * Uses UserDateTimezoneFormat to format the date according to user's timezone
 * @type {import('./types').GridColumn} Column configuration object
 */
export const dateLastUpdatedColumn = {
  name,
  render: (data) => {
    const { modifiedAt } = data;
    return modifiedAt && <UserDateTimezoneFormat dateTime={modifiedAt} />;
  },
  id: advancedShippingNoticeGridProperties.dateLastUpdated,
};
